module.exports = __webpack_public_path__ + "static/polar_ogimage-cfea51bd27f0cc94011df25af71c7c74.jpg";